<template>
    <div>
        <Modal size="md" @close="$emit('close')">
            <template #header>
                <div class="text-gray-600">Promote user</div>
            </template>

            <template #body>
                <div class="p-6">
                    <div class="text-sm text-gray-500">
                        <div>
                            Are you sure you want to give app user with e-mail
                            ({{ newAdmin }}) admin rights?
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        @click="$emit('close')"
                    >
                        Cancel
                    </AtomicButton>
                    <AtomicButton
                        size="md"
                        color="yellow"
                        @click="$emit('promoteUser', newAdmin)"
                    >
                        Promote
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
defineProps({
    newAdmin: {
        type: String,
        default: "",
    },
});

defineEmits(["close", "promoteUser"]);
</script>

<style></style>
